import { Badge } from './Badge'

export type StatusTone = 'positive' | 'info' | 'caution' | 'critical' | 'neutral'

/**
 * A status as a pill.
 *
 * The non-colour marker is `Badge`'s, not this component's. It used to add a
 * second glyph of its own — a bullet in front of Badge's tone mark — so every
 * pill rendered two symbols ("\u2713 \u25cf active"), and the bullet carried no
 * information because it was the same for all five tones. Badge's mark differs
 * per tone, which is the thing that actually survives being read without
 * colour.
 */
export function StatusPill({ label, tone = 'neutral' }: { label: string; tone?: StatusTone }) {
  return <Badge tone={tone}>{label}</Badge>
}
